<div class="mx-auto max-w-(--breakpoint-2xl) px-3">
  <div class="w-full">
    <div class="my-10 text-center">
      <h2 class="text-2xl font-medium text-gray-800 dark:text-white/90">
        @if (venue.id) {
          Edit Venue
        } @else {
          Add Venue
        }
      </h2>
    </div>
  </div>

  <form [formGroup]="form">

    <div class="grid grid-cols-1 xl:grid-cols-2 gap-5 items-start">
      <div class="flex flex-col gap-3 items-start min-w-0">

        <div class="rounded-2xl w-full border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
          <div class="px-5 py-4 sm:px-6 sm:py-5">
            <h3 class="text-base font-medium text-gray-800 dark:text-white/90">
              Contact Information
            </h3>
          </div>
          <div class="p-5 space-y-6 border-t border-gray-100 dark:border-gray-800 sm:p-6">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div>
                <app-text-input [control]="form.controls.name" [name]="'name'" [placeholder]="'Venue Name'" [label]="'Name'"></app-text-input>
              </div>

              <div>
                <app-text-input [control]="form.controls.phone" [name]="'phone'" [placeholder]="'+00 123 456 789'" [label]="'Phone Number'"></app-text-input>
              </div>

              <div class="sm:col-span-2">
                <app-text-input [control]="form.controls.website" [name]="'website'" [placeholder]="'example.com'" [label]="'Website'"></app-text-input>
              </div>

              <div class="sm:col-span-2">
                <app-text-input [control]="form.controls.email" [name]="'email'" [placeholder]="'name@example.com'" [label]="'Email'" [type]="'email'"></app-text-input>
              </div>
            </div>
          </div>
        </div>

        <div class="w-full">
          <div class="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
            <div class="px-5 py-4 sm:px-6 sm:py-5">
              <div class="flex justify-between items-center">
                <h3 class="text-base font-medium text-gray-800 dark:text-white/90">
                  Prices
                </h3>

              </div>
            </div>
            @if (venue.id) {

              <div class="w-full p-3 flex flex-col gap-3">
                <div class="flex flex-wrap justify-between gap-3 items-center">
                  <div>
                    <app-button
                      [label]="'View Calendar'"
                      [icon]="CalendarIcon"
                      [style]="'secondary'"
                      [routerLink]="['/venues', venue.id, 'prices', 'calendar']"
                    >
                    </app-button>
                  </div>
                  @if (isAdmin) {
                    <div class="flex gap-3">
                      <app-button [label]="'Import Prices XLSX'" [disabled]="processing || importPreviewLoading || importConfirming" [style]="'primary'" (click)="importPricesCSV()"></app-button>
                    </div>
                  } @else {
                    <p class="text-sm text-gray-500 dark:text-gray-400">
                      Only admins can import venue pricing.
                    </p>
                  }
                </div>
              </div>
              @if (isAdmin) {
                <input type="file" #csvFileInput accept=".xlsx,.xls" (change)="onCsvFileSelected($event)" style="display: none">
              }
            } @else {
              <div class="p-5 space-y-6 border-t border-gray-100 dark:border-gray-800 sm:p-6">
                <p class="text-sm text-gray-500 dark:text-gray-400">
                  You must save the venue before importing prices.
                </p>
              </div>
            }
          </div>
        </div>

        <app-modal
          [show]="showImportPreview"
          [title]="'Review venue price import: ' + (venue.name || 'Venue')"
          [confirmButtonLabel]="'Import prices'"
          [closeButtonLabel]="'Cancel'"
          [processing]="importConfirming"
          [size]="'wide'"
          (onClose)="closeImportPreview()"
          (onConfirm)="confirmImportPrices()"
        >
          @if (importPreview) {
            <div class="flex min-h-0 flex-col gap-6">
              <div class="flex flex-wrap items-start justify-between gap-4">
                <div class="space-y-2">
                  <p class="text-sm text-gray-500">
                    You are about to import pricing for {{ importPreview.summary.total }} dates.
                  </p>
                  @if (importPreview.summary.date_range.start && importPreview.summary.date_range.end) {
                    <p class="text-sm text-gray-500">
                      Date range:
                      {{ importPreview.summary.date_range.start | date:'d MMM yyyy' }}
                      –
                      {{ importPreview.summary.date_range.end | date:'d MMM yyyy' }}
                    </p>
                  }
                </div>
                <div class="flex flex-wrap gap-3">
                  <div class="rounded-full bg-gray-100 px-4 py-2 text-xs font-semibold text-gray-700">
                    Total {{ importPreview.summary.total }}
                  </div>
                  <div class="rounded-full bg-emerald-50 px-4 py-2 text-xs font-semibold text-emerald-700">
                    New {{ importPreview.summary.create_count }}
                  </div>
                  <div class="rounded-full bg-amber-50 px-4 py-2 text-xs font-semibold text-amber-700">
                    Overwrite {{ importPreview.summary.update_count }}
                  </div>
                  <div class="rounded-full bg-red-50 px-4 py-2 text-xs font-semibold text-red-700">
                    Delete {{ importPreview.summary.delete_count }}
                  </div>
                  <div class="rounded-full bg-gray-100 px-4 py-2 text-xs font-semibold text-gray-600">
                    No change {{ importPreview.summary.skip_count }}
                  </div>
                </div>
              </div>

              <div class="flex-1 min-h-0 overflow-hidden rounded-2xl border border-gray-200">
                <div class="h-full overflow-auto">
                  <table class="min-w-full table-fixed text-sm">
                    <thead class="sticky top-0 bg-gray-50 text-gray-600">
                      <tr>
                        <th class="w-28 px-3 py-3 text-left font-semibold">Action</th>
                        <th class="w-40 px-3 py-3 text-left font-semibold border-l border-gray-100">Date</th>
                        <th class="w-56 px-3 py-3 text-center font-semibold border-l border-gray-100">Venue Hire</th>
                        <th class="w-56 px-3 py-3 text-center font-semibold border-l border-gray-100">Min Spend</th>
                      </tr>
                    </thead>
                    <tbody class="divide-y divide-gray-100">
                      @for (row of importPreview.rows; track row.date) {
                        <tr class="text-gray-700 odd:bg-gray-50/60 hover:bg-gray-100/60">
                          <td class="px-3 py-3 whitespace-nowrap">
                            @if (row.status === 'create') {
                              <span class="inline-flex items-center rounded-full bg-emerald-50 px-2.5 py-1 text-xs font-semibold text-emerald-700">New</span>
                            } @else if (row.status === 'delete') {
                              <span class="inline-flex items-center rounded-full bg-red-50 px-2.5 py-1 text-xs font-semibold text-red-700">Delete</span>
                            } @else if (row.status === 'skip') {
                              <span class="inline-flex items-center rounded-full bg-gray-100 px-2.5 py-1 text-xs font-semibold text-gray-600">No change</span>
                            } @else {
                              <span class="inline-flex items-center rounded-full bg-amber-50 px-2.5 py-1 text-xs font-semibold text-amber-700">Overwrite</span>
                            }
                          </td>
                          <td class="px-3 py-3 whitespace-nowrap font-medium text-gray-900 border-l border-gray-100">
                            {{ row.date | date:'d MMM yyyy' }}
                          </td>
                          <td class="px-3 py-3 text-center whitespace-nowrap border-l border-gray-100">
                            <div class="flex items-center justify-center gap-2">
                              <span class="text-gray-400">
                                @if (row.status === 'delete' && row.previous_hire_price === null) {
                                  <span class="text-gray-500">Unset</span>
                                } @else if (row.previous_hire_price !== null) {
                                  {{ row.previous_hire_price | currency:'GBP':'symbol':'1.0-2' }}
                                } @else {
                                  —
                                }
                              </span>
                              @if (row.status !== 'skip') {
                                <span class="text-gray-300">-&gt;</span>
                                <span
                                  [ngClass]="{
                                    'text-emerald-700': row.status === 'create',
                                    'text-amber-700': row.status === 'update',
                                    'text-red-700': row.status === 'delete'
                                  }"
                                >
                                  @if (row.status === 'delete') {
                                    Deleted
                                  } @else if (row.hire_price !== null) {
                                    {{ row.hire_price | currency:'GBP':'symbol':'1.0-2' }}
                                  } @else {
                                    <span class="text-gray-500">Unset</span>
                                  }
                                </span>
                              }
                            </div>
                          </td>
                          <td class="px-3 py-3 text-center whitespace-nowrap border-l border-gray-100">
                            <div class="flex items-center justify-center gap-2">
                              <span class="text-gray-400">
                                @if (row.status === 'delete' && row.previous_minimum_spend === null) {
                                  <span class="text-gray-500">Unset</span>
                                } @else if (row.previous_minimum_spend !== null) {
                                  {{ row.previous_minimum_spend | currency:'GBP':'symbol':'1.0-2' }}
                                } @else {
                                  —
                                }
                              </span>
                              @if (row.status !== 'skip') {
                                <span class="text-gray-300">-&gt;</span>
                                <span
                                  [ngClass]="{
                                    'text-emerald-700': row.status === 'create',
                                    'text-amber-700': row.status === 'update',
                                    'text-red-700': row.status === 'delete'
                                  }"
                                >
                                  @if (row.status === 'delete') {
                                    Deleted
                                  } @else if (row.minimum_spend !== null) {
                                    {{ row.minimum_spend | currency:'GBP':'symbol':'1.0-2' }}
                                  } @else {
                                    <span class="text-gray-500">Unset</span>
                                  }
                                </span>
                              }
                            </div>
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>

              <p class="text-sm text-gray-500">
                Importing will apply overwrites and deletes shown above. Dates missing from the XLSX will be removed from the database for this venue.
              </p>
            </div>
          } @else {
            <p class="text-sm text-gray-500">No preview data available.</p>
          }
        </app-modal>

        <app-modal
          [show]="importPreviewLoading && !showImportPreview && !showImportSheetPicker"
          [title]="'Processing price file…'"
          [confirm]="false"
          [showFooter]="false"
          [processing]="true"
        >
          <div class="flex flex-col items-center justify-center gap-4 py-10">
            <div class="h-10 w-10 animate-spin rounded-full border-4 border-gray-200 border-t-brand-500"></div>
            <div class="text-sm text-gray-500">
              Reading spreadsheet and preparing preview…
            </div>
          </div>
        </app-modal>

        <app-modal
          [show]="showImportErrorModal"
          [title]="importErrorTitle"
          [confirm]="false"
          [closeButtonLabel]="'Close'"
          (onClose)="closeImportErrorModal()"
        >
          <div class="space-y-4">
            @if (importErrorNote) {
              <div class="rounded-lg border border-gray-200 bg-white px-3 py-2 text-xs font-medium text-gray-500">
                {{ importErrorNote }}
              </div>
            }

            @for (item of importErrorItems; track item.title) {
              <div class="rounded-2xl border border-gray-200 bg-white p-4">
                <div class="flex items-start justify-between gap-3">
                  <div class="min-w-0">
                    <div class="text-sm font-semibold text-gray-900">{{ item.title }}</div>
                    <div class="mt-1 text-sm text-gray-700 whitespace-pre-line">{{ item.message }}</div>
                  </div>
                </div>

                @if (item.examples.length > 0) {
                  <details class="mt-3 rounded-lg bg-gray-50 px-3 py-2">
                    <summary class="cursor-pointer text-xs font-semibold text-gray-600">
                      Show examples ({{ item.examples.length }})
                    </summary>
                    <div class="mt-2 space-y-1">
                      @for (ex of item.examples; track ex) {
                        <div class="font-mono text-xs text-gray-700 break-all">{{ ex }}</div>
                      }
                    </div>
                  </details>
                }
              </div>
            }
          </div>
        </app-modal>

        <app-modal
          [show]="showImportSheetPicker"
          [title]="'Choose XLSX sheet to import: ' + (venue.name || 'Venue')"
          [confirmButtonLabel]="'Load preview'"
          [confirmDisabled]="!selectedImportSheetName"
          [closeButtonLabel]="'Cancel'"
          [processing]="importPreviewLoading"
          [size]="'wide'"
          (onClose)="closeImportSheetPicker()"
          (onConfirm)="confirmImportSheetChoice()"
        >
          <div class="space-y-4">
            <p class="text-sm text-gray-500">
              This XLSX contains multiple sheets that look like venue pricing imports. Pick the correct one to preview.
            </p>
            <div class="space-y-2">
              @for (sheet of importSheetChoices; track sheet) {
                <label class="flex items-center gap-3 rounded-lg border border-gray-200 px-4 py-3 text-sm text-gray-800 hover:bg-gray-50">
                  <input
                    type="radio"
                    name="importSheet"
                    class="h-4 w-4"
                    [value]="sheet"
                    [checked]="selectedImportSheetName === sheet"
                    (change)="selectedImportSheetName = sheet"
                  />
                  <span class="font-medium">{{ sheet }}</span>
                </label>
              }
            </div>
          </div>
        </app-modal>

        <div class="mt-6 w-full">
          <div class="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
            <div class="px-5 py-4 sm:px-6 sm:py-5">
              <div class="flex items-center justify-between">
                <h3 class="text-base font-medium text-gray-800 dark:text-white/90">
                  Quote products
                </h3>
                @if (savingAssignments) {
                  <p class="text-sm text-gray-500">Saving…</p>
                }
              </div>
              <p class="text-sm text-gray-500 dark:text-gray-400 mt-1">Configure Food &amp; Drinks dropdowns for public quote forms.</p>
            </div>
            <div class="p-5 space-y-6 border-t border-gray-100 dark:border-gray-800 sm:p-6">
              @if (!venue.id) {
                <p class="text-sm text-gray-500 dark:text-gray-400">Save the venue first to configure quote products.</p>
              } @else if (!isAdmin) {
                <p class="text-sm text-gray-500 dark:text-gray-400">Only admins can edit quote products.</p>
              } @else {
                <div class="grid grid-cols-1 gap-6">
                  <div class="flex flex-col gap-6">
                    @for (section of quoteProductSections; track section.slug) {
                      <div class="space-y-3">
                        <app-searchable-select
                          [label]="section.label"
                          [control]="quoteProductControls[section.slug]"
                          [initialOptions]="quoteProductChoices[section.slug]"
                          [searchFunction]="quoteProductSearchFunctions[section.slug]"
                          [minSearchLength]="0"
                          [showMeta]="true"
                          placeholder="Search products..."
                          searchPlaceholder="Type to search products..."
                        ></app-searchable-select>

                        <div class="mt-3"></div>

                        @if (quoteProducts[section.slug].length === 0) {
                          <p class="text-sm text-gray-500 dark:text-gray-400">{{ section.emptyLabel }}</p>
                        } @else {
                          @if (quoteProducts[section.slug].length > 1) {
                            <p class="text-xs text-gray-500 dark:text-gray-400">Drag to set the order these appear on the public quote form.</p>
                          }
                          <div class="venue-quote-drop-list space-y-4" cdkDropList (cdkDropListDropped)="onQuoteProductDropped(section.slug, $event)">
                            @for (product of quoteProducts[section.slug]; track product.id) {
                              <div
                                cdkDrag
                                cdkDragPreviewClass="venue-quote-drag-preview"
                                [cdkDragDisabled]="quoteProducts[section.slug].length < 2"
                                class="rounded-lg border border-gray-200 bg-white p-4 dark:border-gray-700 dark:bg-white/[0.03]">
                                <div class="flex items-center justify-between gap-3">
                                  <div class="flex items-start gap-3">
                                    @if (quoteProducts[section.slug].length > 1) {
                                      <button
                                        type="button"
                                        cdkDragHandle
                                        aria-label="Drag to reorder"
                                        class="mt-0.5 cursor-grab text-gray-400 hover:text-gray-600 active:cursor-grabbing dark:text-gray-500 dark:hover:text-gray-300">
                                        <lucide-icon [size]="18" [name]="GripVerticalIcon"></lucide-icon>
                                      </button>
                                    }
                                    <div>
                                      <h4 class="text-sm font-semibold text-gray-900 dark:text-gray-100">
                                        @if (product.id) {
                                          <a
                                            class="text-blue-600 hover:text-blue-700 hover:underline dark:text-blue-400 dark:hover:text-blue-300"
                                            [routerLink]="['/products', product.id, 'edit']">
                                            {{ product.name }}
                                          </a>
                                        } @else {
                                          <span>{{ product.name }}</span>
                                        }
                                      </h4>
                                      <p class="text-xs text-gray-500 dark:text-gray-400">{{ product.category }}</p>
                                    </div>
                                  </div>
                                  <div class="flex items-center gap-3">
                                    @if (getProductPriceLabel(product)) {
                                      <span class="text-xs text-gray-500 dark:text-gray-400">
                                        {{ getProductPriceLabel(product) }}
                                      </span>
                                    }
                                    <button
                                      type="button"
                                      class="text-xs font-medium text-red-600 hover:text-red-700"
                                      (click)="removeQuoteProduct(section.slug, product)">
                                      Remove
                                    </button>
                                  </div>
                                </div>

                                @if (product.is_variant_based) {
                                  @for (variant of getSortedVariants(product); track variant.id) {
                                    <div class="mt-4">
                                      <h5 class="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">{{ variant.name }}</h5>
                                      @if (!variant.options || variant.options.length === 0) {
                                        <p class="text-xs text-gray-500 dark:text-gray-400 mt-2">No options for this variant.</p>
                                      } @else {
                                        <div class="mt-2 space-y-2">
                                          @for (option of getSortedOptions(variant); track option.id) {
                                            <label class="flex items-center gap-2 text-sm text-gray-800 dark:text-gray-100">
                                              <input
                                                type="checkbox"
                                                class="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                [checked]="isVariantOptionSelected(section.slug, option.id)"
                                                (change)="toggleVariantOption(section.slug, option.id)">
                                              <span class="flex-1">{{ option.name }}</span>
                                              <span class="text-xs text-gray-500 dark:text-gray-400">
                                                {{ formatOptionMeta(option) }}
                                              </span>
                                            </label>
                                          }
                                        </div>
                                      }
                                    </div>
                                  }
                                }
                              </div>
                            }
                          </div>
                        }
                      </div>
                    }

                    <div class="flex justify-end lg:justify-start">
                      <app-button [label]="'Save'" [style]="'primary'" [disabled]="savingAssignments" (click)="saveQuoteAssignments()"></app-button>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>

      </div>

      <div class="flex flex-col gap-5">

        <div class="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
          <div class="px-5 py-4 sm:px-6 sm:py-5">
            <h3 class="text-base font-medium text-gray-800 dark:text-white/90">
              Address
            </h3>
          </div>
          <div class="p-5 space-y-6 border-t border-gray-100 dark:border-gray-800 sm:p-6">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
              <div>
                <app-text-input [control]="form.controls.address" [name]="'address'" [placeholder]="'123 Street'" [label]="'Address'"></app-text-input>
              </div>
              <div>
                <app-text-input [control]="form.controls.city" [name]="'city'" [placeholder]="'Some City'" [label]="'City'"></app-text-input>
              </div>
              <div>
                <app-text-input [control]="form.controls.region" [name]="'county'" [placeholder]="'Some County'" [label]="'County'"></app-text-input>
              </div>
              <div>
                <app-text-input [control]="form.controls.postal_code" [name]="'postal_code'" [placeholder]="'1A1 B2B'" [label]="'Postcode'"></app-text-input>
              </div>

              <div>
                <app-select [control]="form.controls.country" [choices]="Countries.countryChoices()" label="Country"></app-select>
              </div>
            </div>
          </div>

          <div class="px-5 py-4 sm:px-6 sm:py-5">
            <h3 class="text-base font-medium text-gray-800 dark:text-white/90">
              Additional Information
            </h3>
          </div>
          <div class="p-5 space-y-6 border-t border-gray-100 dark:border-gray-800 sm:p-6">
            <textarea [placeholder]="'Enter text here...'" [formControl]="form.controls.info" type="text" rows="6"
                      class="dark:bg-dark-900 shadow-theme-xs focus:border-brand-300 focus:ring-brand-500/10 dark:focus:border-brand-800 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 placeholder:text-gray-400 focus:ring-3 focus:outline-hidden dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"></textarea>
          </div>

        </div>


        <div class="w-full">

          <div class="rounded-2xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
            <div class="px-5 py-4 sm:px-6 sm:py-5">
              <h3 class="text-base font-medium text-gray-800 dark:text-white/90">
                Images
              </h3>
            </div>
            <div class="p-5 space-y-6 border-t border-gray-100 dark:border-gray-800 sm:p-6">
              <div class="space-y-5">

                <div class="sm:col-span-2">
                  <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">
                    Image
                  </label>
                  @if (imageUrl) {
                    <img [src]="imageUrl" alt="Selected Image" class="mt-2 w-[300px]">
                  } @else {
                    @if (venue.images.length > 0 && venue.images[0].sm) {
                      <img [src]="venue.images[0].sm" alt="Existing Image" class="mt-2 w-[300px]">
                    }
                  }
                  <div class="w-full mt-5">
                    <input type="file" (change)="onFileChange($event, 'image')"
                           class="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full
                       file:border-0 file:text-sm file:font-semibold file:bg-brand-50 file:text-brand-700 hover:file:bg-brand-100">
                  </div>
                </div>

                <div class="sm:col-span-2">
                  <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">
                    Logo
                  </label>
                  @if (logoUrl) {
                    <img [src]="logoUrl" alt="Selected Logo" class="mt-2 w-[300px]">
                  } @else {
                    @if (venue.logos.length > 0 && venue.logos[0].sm) {
                      <img [src]="venue.logos[0].sm" alt="Existing Logo" class="mt-2 w-[300px]">
                    }
                  }
                  <div class="w-full mt-5">
                    <input type="file" (change)="onFileChange($event, 'logo')"
                           class="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full
                       file:border-0 file:text-sm file:font-semibold file:bg-brand-50 file:text-brand-700 hover:file:bg-brand-100">
                  </div>
                </div>

                <div class="sm:col-span-2">
                  <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-400">
                    Map
                  </label>
                  @if (mapUrl) {
                    <img [src]="mapUrl" alt="Selected Map" class="mt-2 w-[300px]">
                  } @else {
                    @if (venue.maps.length > 0 && venue.maps[0].sm) {
                      <img [src]="venue.maps[0].sm" alt="Existing Map" class="mt-2 w-[300px]">
                    }
                  }
                  <div class="w-full mt-5">
                    <input type="file" (change)="onFileChange($event, 'map')"
                           class="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full
                       file:border-0 file:text-sm file:font-semibold file:bg-brand-50 file:text-brand-700 hover:file:bg-brand-100">
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>

      </div>
    </div>


    <div class="mt-8 flex flex-row items-center justify-end gap-3">
      <app-button
        [label]="'Cancel'"
        [icon]="XIcon"
        [style]="'secondary'"
        [disabled]="processing"
        (click)="cancel()"
      ></app-button>

      <app-button
        [label]="'Save & Continue'"
        [icon]="CheckCircleIcon"
        [style]="'secondary'"
        [disabled]="processing || !form.valid || form.pristine"
        (click)="saveAndContinue()"
      ></app-button>

      <app-button
        [label]="'Save'"
        [icon]="CheckCircleIcon"
        [style]="'primary'"
        [disabled]="processing || !form.valid || form.pristine"
        (click)="save()"
      ></app-button>
    </div>

    <!--  @if (validationErrors.length > 0) {-->
    <!--    <div class="mt-4 p-4 border border-red-500 bg-red-100 text-red-700 rounded-lg">-->
    <!--      <h3 class="font-medium">Validation Errors:</h3>-->
    <!--      <ul class="list-disc list-inside">-->
    <!--        @for (error of validationErrors; track error) {-->
    <!--          <li>{{ error }}</li>-->
    <!--        }-->
    <!--      </ul>-->
    <!--    </div>-->
    <!--  }-->

  </form>


</div>
